import { Grid } from "@material-ui/core";
import { useEffect, useState } from "react";
import { EditButton, SimpleForm, TextInput, TopToolbar } from "react-admin";
import { useForm } from "react-final-form";
import { OnChange } from "react-final-form-listeners";
import { MyDateTimeInput } from "./../../../MyDateTimeInput";
import { MenuTreeCreatePopup } from "./../components/menu-tree-create-popup";

// popup
import { Add, Menu } from "@material-ui/icons";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";

export const CustomEditAction = (props) => {
  return (
    <>
      <TopToolbar>
        <SimpleForm toolbar={false} style={{ flexGrow: "1" }}>
          <TopInputs start_time={props.start_time} description={props.description} startTimeChangeCallback={props.startTimeChangeCallback} descriptionChangeCallback={props.descriptionChangeCallback} />
        </SimpleForm>
        <SimpleForm toolbar={false}>
          <Popup
            open={props.popupOpen}
            arrow={false}
            closeOnDocumentClick={false}
            onClose={() => {
              props.setPopupOpen(false);
            }}
            trigger={
              <>
                <EditButton
                  label="Create menu item"
                  variant="outlined"
                  icon={<Add />}
                  onClick={() => {
                    props.setEditRow(false);
                    props.setPopupOpen(true);
                  }}
                />
              </>
            }
          >
            <MenuTreeCreatePopup //
              addMenuItemCallback={props.addMenuItemCallback}
              updateMenuItemCallback={props.updateMenuItemCallback}
              removeMenuItemCallback={props.removeMenuItemCallback}
              closeMenuItemCallback={props.closeMenuItemCallback}
              getMenuItemParent={props.getMenuItemParent}
              editRow={props.editRow}
            />
          </Popup>

          <>
            <EditButton
              label="Change order"
              variant="outlined"
              icon={<Menu />}
              onClick={() => {
                props.changeOrderCallback();
              }}
            />
          </>
        </SimpleForm>
      </TopToolbar>
    </>
  );
};

const TopInputs = (props) => {
  const form = useForm();

  const [initialStartTime, setInitialStartTime] = useState(props.start_time);
  const [initialDescription, setInitialDescription] = useState(props.description);

  useEffect(() => {
    form.change("start_time", initialStartTime);
    form.change("description", initialDescription);
  }, []);

  return (
    <Grid item sm={12} md={12} style={{ flexGrow: "1", width: "100%" }}>
      <Grid item sm={12} md={12} style={{ flexGrow: "1" }}>
        <MyDateTimeInput source="start_time" label="Effective Time" showTime />
        <OnChange name="start_time">
          {(value) => {
            props.startTimeChangeCallback(value);
            setInitialStartTime(value);
          }}
        </OnChange>
      </Grid>
      <Grid item sm={12} md={12} style={{ flexGrow: "1" }}>
        <TextInput source="description" label="Description" style={{ flexGrow: "1", width: "100%" }} />
        <OnChange name="description">
          {(value) => {
            props.descriptionChangeCallback(value);
            setInitialDescription(value);
          }}
        </OnChange>
      </Grid>
    </Grid>
  );
};
